export const ADD_SHIFT_SUCCESS = "redux_store:shifts.success.add";
export const DELETE_SHIFT_SUCCESS = "redux_store:shifts.success.delete";
export const UPDATE_SHIFT_SUCCESS = "redux_store:shifts.success.update";

export const ADD_CLOSED_DAY_SUCCESS = "redux_store:shifts.success.add_closed_day";
export const DELETE_CLOSED_DAY_SUCCESS = "redux_store:shifts.success.delete_closed_day";
export const UPDATE_CLOSED_DAY_SUCCESS = "redux_store:shifts.success.update_closed_day";



// WEBPACK FOOTER //
// ./src/successes/shifts.js